import { get, post, put, del } from '@/lib/api/client'
import type {
  ApiResponse,
  PaginatedResponse,
  PaginationParams,
  Event,
  EventStats,
  CreateEvent,
  UpdateEvent,
  UpdateEventStatus,
  EventFilterParams
} from '@/lib/api/types'

export const eventService = {
  // Filter events with pagination
  filterEvents: async (
    params: PaginationParams = { page: 1, size: 10 },
    filters: EventFilterParams = {}
  ): Promise<ApiResponse<PaginatedResponse<Event>>> => {
    return await post<ApiResponse<PaginatedResponse<Event>>>(
      `events/private/filter?size=${params.size}&page=${params.page}`,
      filters
    )
  },

  // Get event by ID (public endpoint)
  getEventById: async (eventId: string): Promise<ApiResponse<Event>> => {
    return await get<ApiResponse<Event>>(`events/private/${eventId}`)
  },

  // Create a new event
  createEvent: async (data: CreateEvent): Promise<ApiResponse<Event>> => {
    return await post<ApiResponse<Event>>(
      'events/admin/private',
      data
    )
  },

  // Update an existing event
  updateEvent: async (
    eventId: string,
    data: UpdateEvent
  ): Promise<ApiResponse<Event>> => {
    return await put<ApiResponse<Event>>(
      `events/admin/private/${eventId}`,
      data
    )
  },

  // Update event status
  updateEventStatus: async (
    eventId: string,
    data: UpdateEventStatus
  ): Promise<ApiResponse<null>> => {
    return await put<ApiResponse<null>>(
      `events/admin/private/${eventId}/status`,
      data
    )
  },

  // Delete an event
  deleteEvent: async (eventId: string): Promise<ApiResponse<null>> => {
    return await del<ApiResponse<null>>(
      `events/private/${eventId}`
    )
  },

  // Get published events count
  getPublishedEventsCount: async (): Promise<ApiResponse<number>> => {
    return await get<ApiResponse<number>>('events/private/stats/published')
  },

  // Get draft events count
  getDraftEventsCount: async (): Promise<ApiResponse<number>> => {
    return await get<ApiResponse<number>>('events/private/stats/draft')
  },

  // Get event stats
  getEventStats: async (): Promise<ApiResponse<EventStats>> => {
    return await get<ApiResponse<EventStats>>('events/private/stats')
  },

  // Search events
  searchEvents: async (
    searchBy?: string
  ): Promise<ApiResponse<PaginatedResponse<Event>>> => {
    const queryParams = new URLSearchParams()
    
    if (searchBy !== undefined) {
      queryParams.append('searchBy', searchBy)
    }

    return await get<ApiResponse<PaginatedResponse<Event>>>(
      `events/private/search?${queryParams.toString()}`
    )
  }
}

